// Guided tours (#160). Each step spotlights the element with that
// data-tour attribute, after switching to `view` if it's on another tab.
// Write steps like help (one or two short sentences, buttons in bold words
// as they appear) and update them in the same change as the screen.

export const TOURS = {
  basics: {
    title: "The basics",
    steps: [
      {
        view: "session",
        target: "today",
        title: "Start here",
        body: "Today's session, picked for your week. Start builds it and runs it.",
      },
      {
        view: "session",
        target: "more-ways",
        title: "Other ways to start",
        body: "Just train and log as you go, build your own, run a timer, or log a workout you did elsewhere.",
      },
      {
        target: "nav-coach",
        title: "The Coach",
        body: "Runs your workout step by step. Tap the ring to start or pause; on a reps step, press Done.",
      },
      {
        target: "nav-activity",
        title: "Activity",
        body: "Your last 7 days against your weekly targets, and everything you've done.",
      },
      {
        target: "nav-programme",
        title: "Programmes",
        body: "Follow a plan over several weeks. Khronos builds each session as you reach it.",
      },
      {
        target: "help",
        title: "Help, any time",
        body: "Everything is explained here, and the small ? next to a setting opens the right page.",
      },
    ],
  },
};

/** Every data-tour id the tours point at (for the test that they exist). */
export const tourTargets = () => [...new Set(Object.values(TOURS).flatMap((t) => t.steps.map((s) => s.target)))];
